export default function modelContentPage(items) {
  var step = [];
  if (items.content && items.content.articles) {
    step = items.content.articles.map(item => {
      let values = "";

      if (item.template && item.template.values) {
        try {
          values = JSON.parse(item.template.values);
        } catch (e) {}
      }

      return {
        ...item,
        template: {
          ...item.template,
          values: values
        }
      };
    });
  }
  let returnable = [];
  let set = [];
  step.forEach(item => {
    if (item.template.mode.toLowerCase() === "set") {
      set.push(item);
    } else {
      if (set.length > 0) {
        let pushableSet = { ...set[0] };
        pushableSet.set = [...set];
        returnable.push(pushableSet);
        set = [];
      }

      returnable.push(item);
    }
  });
  if (set.length > 0) {
    let pushableSet = { ...set[0] };
    pushableSet.set = [...set];
    returnable.push(pushableSet);
    set = [];
  }

  return returnable;
}



// WEBPACK FOOTER //
// ./src/redux/models/contentPage.js